<template>
  <v-content>
    <!-- <v-alert
      v-model="alert"
      dismissible
      type="success"
    >
    Link has been sent, you will be directed back to the login screen.
    </v-alert> -->
    <v-container
      fluid
      fill-height
    >
      <v-layout
        align-center
        justify-center
      >
        <v-flex
          xs12
          sm8
          md4
        >
          <v-card class="elevation-12">
            <v-toolbar
              dark
              color="primary"
            >
              <v-toolbar-title>Password Reset</v-toolbar-title>
              <v-spacer />
            </v-toolbar>
            <v-card-text>
              <v-form>
                <!-- <v-text-field
                  prepend-icon="email"
                  browser-autocomplete="disabled"
                  v-model=""
                  :label=""
                  type="text"
                  :rules=""
                ></v-text-field>
                <v-text-field
                  prepend-icon="email"
                  browser-autocomplete="disabled"
                  v-model=""
                  :label=""
                  type="text"
                  :rules=""
                ></v-text-field> -->
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="primary"
                @click="submit()"
              >
                <!-- {{$t("message.password_reset")}} -->
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import { mapActions } from "vuex";
import rules from "@/validation.js";
import esrules from "@/esvalidation.js";
import validations from "@/validation.js";

export default {
  data() {
    return {
      //   email: "",
      rules: rules.rules,
      esrules: esrules.esrules
      //   alert: false,
    };
  },
  computed: {
    // emailMessage() {
    //   return this.$t("message.email");
    // },
    // emailrules: function() {
    //   if (this.$i18n.locale === "en") {
    //     return this.rules.emailRules;
    //   } else {
    //     return this.esrules.emailRules;
    //   }
    // },
  },
  validations: validations.validations,
  methods: {
    ...mapActions("auth", ["passwordResetConfirm"])
    // submit(){
    //     this.passwordReset(this.email);
    //     this.alert = true;
    //     setTimeout(()=> this.cancel() , 5000)
    //     // this.cancel();
    // },
    // cancel(){
    //   this.$router.push("/login");

    // }
  }
};
</script>
